<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Account Recovery</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createAccount">Recover Account</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="accounts.columns" :data="accounts.data">
                    <template slot="table-row" v-if="accounts.data.length">
                        <tr v-for="(item, index) in accounts.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.oldEmail}}</td>
                            <td>{{item.newEmail}}</td>
                            <td>{{item.createdOn.toString().substr(0, 10)}}</td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const accountsColumns = ['Old Email', 'New Email', 'Recovery Date'];
    export default {
        name: 'Accounts',
        components: {
            LTable,
        },
        data() {
        return {
              accounts: {
                columns: [...accountsColumns],
                tableRowClass: {
                    classname: 'badge-warning',
                    classActiveCondition: 'status'
                },
                data: []
    }
    }
    },
    methods: {
        fetchAccounts () {
            this.$store.dispatch('FETCH_ACCOUNTS')
                    .then((res) => {
                      console.log('accounts', res)
                        this.accounts.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        createAccount(){
            this.$router.push({ name: 'CreateAccount'})
        }
    },
    created() {
        this.fetchAccounts();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Accounts.vue